import animate from './animate';

/**
 * Scroll an HTML element in to view
 * Opinionated - will scroll the element to the viewport (window) center
 * @param {HTMLElement} element the HTML element to calculate position
 * @param {Function} onStart the callback when animation starts
 * @param {Function} onComplete the callback when animation completes
 */
/* istanbul ignore next */
export default function scrollIntoView<T extends HTMLElement = HTMLElement>(
  element?: T | null,
  onStart: () => void = () => {},
  onComplete: () => void = () => {}
): void {
  if (!element) return;
  animate({
    fromValue: window.scrollY,
    toValue: element.offsetTop - window.innerHeight / 2 + element.offsetHeight / 2,
    onStart,
    onUpdate: (scrollTop: number, next: () => void) => {
      window.scrollTo({ left: 0, top: scrollTop });
      next();
    },
    onComplete,
  });
}
